import { Pipe, PipeTransform } from '@angular/core';
import { ProductAttribute } from '../models/product';
import { PricePipe } from './price.pipe';

@Pipe({
  name: 'productAttributeValue',
  standalone: true,
})
export class ProductAttributeValuePipe implements PipeTransform {
  private pricePipe = new PricePipe();

  transform(attr: ProductAttribute | null | undefined): string {
    if (!attr || attr.value == null) {
      return '';
    }

    const rawValue = String(attr.value).trim();
    if (!rawValue) {
      return '';
    }

    const type = (attr.type || 'string').toLowerCase();

    switch (type) {
      case 'datetime':
        return this.formatDateTime(rawValue);
      case 'money':
        return this.formatMoney(rawValue);
      case 'url':
        // For URLs we only format the display label here; the anchor tag is handled in the template.
        return this.formatUrlLabel(rawValue);
      case 'string':
      default:
        return rawValue;
    }
  }

  private formatDateTime(value: string): string {
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return value;
    }

    // Basic, locale-sensitive formatting; kept simple to avoid extra dependencies.
    // Example output: "4 Jan 2026, 21:30".
    return new Intl.DateTimeFormat(undefined, {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  }

  private formatMoney(value: string): string {
    const formatted = this.pricePipe.transform(value);
    if (!formatted) {
      return value;
    }
    // Default currency symbol; adjust if your backend conveys currency separately.
    return `€ ${formatted}`;
  }

  private formatUrlLabel(value: string): string {
    try {
      return new URL(value).hostname;
    } catch {
      return value.replace(/^https?:\/\//i, '').split('/')[0];
    }
  }
}

